module.exports = __webpack_public_path__ + "static/img/bouton-changer-de-vue.dca0193.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bouton-changer-de-vue.png
// module id = 690
// module chunks = 1